import { render, staticRenderFns } from "./AdminHospitalDoctorList.vue?vue&type=template&id=1224494c&scoped=true"
import script from "./AdminHospitalDoctorList.vue?vue&type=script&lang=js"
export * from "./AdminHospitalDoctorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224494c",
  null
  
)

export default component.exports